// Size mapping (case-insensitive)
const sizeMap = {
  "small": "s",
  "medium": "m",
  "large": "l",
  "extra large": "xl",
  "xl": "xl",
  "2xl": "2xl",
  "3xl": "3xl"
  // Add more if needed
};

// Cache product JSON to avoid multiple fetches
const productCache = new Map();

async function getProductJSON(handle) {
  if (productCache.has(handle)) return productCache.get(handle);
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    const product = await res.json();
    productCache.set(handle, product);
    return product;
  } catch (e) {
    console.error(`Error fetching product JSON for ${handle}`, e);
    return null;
  }
}

async function addSizeChipsToCards() {
  const cards = document.querySelectorAll('.grid__item');

  for (const card of cards) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) continue;

    const handle = link.getAttribute('href').split('/products/')[1].split('?')[0];
    const product = await getProductJSON(handle);
    if (!product) continue;

    // Find the "Size" option
    const sizeOption = product.options.find(o => o.name.toLowerCase() === "size");
    if (!sizeOption) continue;

    const container = card.querySelector('.card-information');
    if (!container) continue;

    // Create chip container
    const chipContainer = document.createElement("div");
    chipContainer.className = "size-chips";

    sizeOption.values.forEach(sizeValue => {
const normalized = sizeValue
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

      // Strict numeric check (integers or decimals only)
      const isNumeric = /^\d+(\.\d+)?$/.test(normalized);

      // Use numeric directly, otherwise fallback to map
      const shortLabel = isNumeric ? normalized : sizeMap[normalized];

      // Only render chip if numeric OR mapped
      if (!shortLabel) return;

      const variant = product.variants.find(v =>
        v.options.includes(sizeValue)
      );

      const span = document.createElement("span");
      span.className = "size-chip " + (variant && variant.available ? "in-stock" : "out-stock");
      span.textContent = shortLabel;

      chipContainer.appendChild(span);
    });

    container.appendChild(chipContainer);
  }
}

// Wait for DOM ready
document.addEventListener("DOMContentLoaded", () => {
  // Slight delay to allow Smile.IO cards to render asynchronously
  setTimeout(addSizeChipsToCards, 1000);
});